import { GOODCO_ORG_ID } from "@remi/constants/users";
import { isOneOf } from "@remi/ts-utils";

import { hasCapability, type User } from "../base";

// Ops uses area caps to throttle contractors, so self-serve is opt-in per org.
const SELF_SERVE_CAPACITY_ORG_IDS = [GOODCO_ORG_ID] as const;

export const serviceAreaCapacity = {
  update: (user: User, contractorProfileId: string) => {
    if (hasCapability(user, "serviceArea.update") && hasCapability(user, "adminTools.read")) {
      return true;
    }
    return (
      user.person.organizationId === contractorProfileId &&
      isOneOf(contractorProfileId, SELF_SERVE_CAPACITY_ORG_IDS) &&
      hasCapability(user, "serviceArea.capacity.org")
    );
  },
};
